import { render, staticRenderFns } from "./GuideOther.vue?vue&type=template&id=1145e9a3"
import script from "./GuideOther.vue?vue&type=script&lang=js"
export * from "./GuideOther.vue?vue&type=script&lang=js"
import style0 from "./GuideOther.vue?vue&type=style&index=0&id=1145e9a3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports